import { render, staticRenderFns } from "./PeriodMetrics.vue?vue&type=template&id=19903915&scoped=true"
import script from "./PeriodMetrics.js?vue&type=script&lang=js&external"
export * from "./PeriodMetrics.js?vue&type=script&lang=js&external"
import style0 from "./PeriodMetrics.scss?vue&type=style&index=0&id=19903915&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19903915",
  null
  
)

export default component.exports